// Utilitário para formatar valores monetários
function formatCurrency(value: number, currency: string = 'BRL', locale: string = 'pt-BR') {
    return value.toLocaleString(locale, { style: 'currency', currency });
}

interface BudgetTotalFooterProps {
    subtotal: number;
    aliquota: number;
    profitMargin?: number;
    total: number;
}

export function BudgetTotalFooter({ subtotal, aliquota, profitMargin = 0, total }: BudgetTotalFooterProps) {
    const aliquotaValue = subtotal * (aliquota / 100);
    const profitMarginValue = subtotal * ((profitMargin || 0) / 100);

    return (
        <div className="fixed inset-x-0 bottom-0 z-[1200] border-t-2 border-primary-600 bg-white p-2 shadow-[0_-2px_12px_rgba(0,0,0,0.15)] dark:bg-slate-800 sm:p-3">
            <div className="flex w-full flex-wrap items-start justify-center gap-x-6 gap-y-2 text-left sm:flex-nowrap sm:items-center sm:text-center">
                <span className="min-w-[120px] text-sm text-slate-700 dark:text-slate-200">
                    Subtotal: <b>{formatCurrency(subtotal)}</b>
                </span>
                <span className="min-w-[140px] text-sm text-slate-700 dark:text-slate-200">
                    Alíquota ({aliquota}%): <b>{formatCurrency(aliquotaValue)}</b>
                </span>
                {profitMargin ? (
                    <span className="min-w-[180px] text-sm text-slate-700 dark:text-slate-200">
                        Margem de Lucro ({profitMargin}%): <b>{formatCurrency(profitMarginValue)}</b>
                    </span>
                ) : null}
                <span className="min-w-[180px] text-base font-semibold text-primary-600 dark:text-primary-400">
                    Total Orçamento: <b>{formatCurrency(total)}</b>
                </span>
            </div>
        </div>
    );
}
